export default __webpack_public_path__ + "static/surfer-924a2c19316c0376abea94342e21f152.jpeg";